import { useCallback, useEffect, useState } from 'react';

const pages = [
  'Arena',
  'Explore',
  'Leaderboard',
  'Points',
  'Profile',
  'My predictions',
];

function currentView() {
  const page = new URLSearchParams(window.location.search).get('page');
  return pages.find((view) => view.toLowerCase() === page) ?? 'Arena';
}

/** A page change never changes the feed mode or opts the user into the demo. */
export function useAppNavigation() {
  const [view, setView] = useState(currentView);
  useEffect(() => {
    const onPopState = () => setView(currentView());
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);
  const navigate = useCallback((next: string) => {
    if (!pages.includes(next)) return;
    const url = new URL(window.location.href);
    if (next === 'Arena') url.searchParams.delete('page');
    else url.searchParams.set('page', next.toLowerCase());
    if (url.href !== window.location.href)
      window.history.pushState(null, '', url);
    setView(next);
  }, []);
  return [view, navigate] as const;
}
